<template>
    <div class="animated fadeIn">
        <div>
            <b-row v-if="loading">
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <b-row class="align-items-center">
                <b-col md="9">
                    <h3 class="mb-0">Order Report</h3>
                </b-col>
                <b-col md="3" class="align-items-right text-right">
                    <b-button
                        style="margin-left: 100px"
                        variant="primary"
                        @click="
                            $router.push({
                                name: 'history',
                                params: { type: 'ORDER' },
                            })
                        "
                    >
                        View Download History
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col md="9" class="pt-0 pb-0">
                    <h4>Order Dashboard</h4>
                </b-col>
                <!-- <b-col md="1" class="text-right pt-0 pb-0">
                    <a href="#">
        <img
          src="@/assets/images/DataExport.png"
          class="upload-btn"
          alt="data export"  
        /></a> -->

                <b-col md="3" class="pt-0 pb-0 align-items-right text-right">
                    <eb-select
                        ref="dateRef2"
                        style="background-color: #fff"
                        id="text"
                        type="text"
                        label="text"
                        :options="dateOption2"
                        v-model="selectedDate2"
                        :selected="selectedDate2.text"
                        @input="changeDate2"
                    >
                    </eb-select>
                    <c-date
                        ref="compRefs2"
                        modalRef="modalRef2"
                        modalId="dateModal2"
                        @customDateRange="findDateResult2"
                    ></c-date>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-card-group deck>
                        <b-card class="total-order-header mt-0">
                            <template #header>
                                <div class="d-flex justify-content-between">
                                    <h4 class="text-white">Total Order</h4>
                                    <h3 class="text-white text-right">
                                        {{ totalOrder }}/{{ orderCount }}
                                    </h3>
                                </div>
                            </template>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">
                                    Pay on Delivery
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ deliveryOrder }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ deliveryCount }}
                                </h4>
                            </div>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Pre Paid</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ prePaidOrder }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ prePaidOrderCount }}
                                </h4>
                            </div>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Product</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ productOrder }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ productOrderCount }}
                                </h4>
                            </div>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Service</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ serviceOrders }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ serviceCount }}
                                </h4>
                            </div>
                        </b-card>
                    </b-card-group>
                </b-col>
                <b-col md="6">
                    <b-card-group deck>
                        <b-card class="orderbyStatus-header mt-0">
                            <template #header>
                                <div class="d-flex justify-content-between">
                                    <h4 class="text-white">Order by Status</h4>
                                </div>
                            </template>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Completed</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ completedOrders }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ completedCount }}
                                </h4>
                            </div>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Pending</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ pendingOrders }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ pendingOrdersCount }}
                                </h4>
                            </div>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Processing</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ ongoingOrders }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ ongoingOrdersCount }}
                                </h4>
                            </div>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Cancelled</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ cancelledOrders }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ cancelledOrderCount }}
                                </h4>
                            </div>
                            <!-- <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Returned</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु 50000000</h4>
                <h4 class="col-md-4 pt-0 pb-0">10980</h4>
              </div> -->
                        </b-card>
                    </b-card-group>
                </b-col>
                <b-col md="6">
                    <b-card-group deck>
                        <b-card class="orderbySale-header">
                            <template #header>
                                <div class="d-flex justify-content-between">
                                    <h4 class="text-white">
                                        Order by Sales Channel
                                    </h4>
                                </div>
                            </template>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">POS</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ posOrder }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ posOrderCount }}
                                </h4>
                            </div>
                            <div class="row">
                                <h4 class="col-md-4 pt-0 pb-0">Online</h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    रु {{ onlineOrder }}
                                </h4>
                                <h4 class="col-md-4 pt-0 pb-0">
                                    {{ onlineOrderCount }}
                                </h4>
                            </div>
                            <!-- <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">In Store</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु 50000000</h4>
                <h4 class="col-md-4 pt-0 pb-0">10980</h4>
              </div> -->
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col md="6">
                    <b-row>
                        <b-col md="4" class="text-right">
                            <a href="#">
                                <img
                                    src="@/assets/images/DataExport.png"
                                    class="upload-btn"
                                    alt="data export"
                                    @click="createRequest"
                                />
                            </a>
                        </b-col>
                        <b-col md="4">
                            <ev-select
                                style="background-color: #fff"
                                id="text"
                                type="text"
                                label="text"
                                placeholder="Select Status"
                                :options="statusOptions"
                                v-model="selectedStatusOptions"
                                :selected="selectedStatusOptions"
                                @input="changeStatus"
                            >
                            </ev-select>
                        </b-col>
                        <b-col md="4">
                            <eb-select
                                ref="dateRef"
                                style="background-color: #fff"
                                id="text"
                                type="text"
                                label="text"
                                :options="dateOption"
                                v-model="selectedDate"
                                :selected="selectedDate.text"
                                @input="changeDate"
                            >
                            </eb-select>
                            <c-date
                                ref="compRefs"
                                modalRef="modalRef"
                                modalId="dateModal"
                                @customDateRange="findDateResult"
                            ></c-date>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" class="pt-0">
                            <b-card class="mt-0" style="height: 100%">
                                <h4>Order by Status</h4>
                                <div
                                    v-if="
                                        getChartData &&
                                        getChartData.labels &&
                                        getChartData.labels.length > 0
                                    "
                                    class="mt-2"
                                >
                                    <Doughnut
                                        class="doughnut chart-doughnut"
                                        :chart-data="getChartData"
                                        :chart-options="chartOptions"
                                    >
                                    </Doughnut>
                                </div>
                                <div v-else>
                                    <h4 class="text-center no-data-margin">
                                        No Data Available
                                    </h4>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="2"></b-col>
                        <b-col md="2" class="text-right">
                            <!-- <a href="#">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            /></a> -->
                        </b-col>
                        <b-col md="4">
                            <ev-select
                                style="background-color: #fff"
                                id="text"
                                type="text"
                                label="text"
                                placeholder="Select Status"
                                :options="statusOptions"
                                v-model="selectedStatusOptions1"
                                :selected="selectedStatusOptions1"
                                @input="changeStatus1"
                            >
                            </ev-select>
                        </b-col>
                        <b-col md="4">
                            <eb-select
                                ref="dateRef1"
                                style="background-color: #fff"
                                id="text"
                                type="text"
                                label="text"
                                :options="dateOption1"
                                v-model="selectedDate1"
                                :selected="selectedDate1.text"
                                @input="changeDate1"
                            >
                            </eb-select>
                            <c-date
                                ref="compRefs1"
                                modalRef="modalRef1"
                                modalId="dateModal1"
                                @customDateRange="findDateResult1"
                            ></c-date>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" class="pt-0">
                            <b-card class="mt-0" style="height: 100%">
                                <h4>Order Value vs Order</h4>
                                <div
                                    v-if="
                                        chartData &&
                                        chartData.labels &&
                                        chartData.labels.length > 0
                                    "
                                    class="mt-2"
                                >
                                    <BarChart
                                        :chart-data="chartData"
                                        :chart-options="barChartOptions1"
                                        class="h-100"
                                    />
                                </div>
                                <div v-else>
                                    <h4 class="text-center no-data-margin">
                                        No Data Available
                                    </h4>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <!-- <b-row>
      <b-col md="5">
        <b-row>
          <b-col md="2" class="text-right">
            <a href="#">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            />
            </a>
          </b-col>
          <b-col md="5">
            <eb-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              :options="dateOption"
              v-model="selectedDate"
              :selected="selectedDate.text"
              @input="changeDate"
            >
            </eb-select>
            <b-modal
              title="Select Date"
              header-class="header-nipige-class"
              id="dateRange"
              size="sm"
              ref="date-range"
              centered
              hide-footer
            >
              <b-input class="mb-2" type="date" v-model="startDate"></b-input>
              <b-input type="date" v-model="endDate"></b-input>
              <div class="text-center mt-2">
                <b-button
                  @click="findButtonClick()"
                  class="my -0 main-navigation-button w-47 mr-2"
                  variant="success"
                >
                  Find
                </b-button>
              </div>
            </b-modal>
          </b-col>
          <b-col md="5">
            <ev-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              placeholder="Select Status"
              :options="statusOptions"
              v-model="selectedStatusOptions"
              :selected="selectedStatusOptions.text"
              @input="changeStatus"
            >
            </ev-select>
          </b-col>
        </b-row>
        <b-row class="mt-0">
            <b-col md="12" class="pt-0">
              <b-card style="height:100%">
                <h4>Order by Market</h4>
                  <div
                    v-if="
                      getChartData &&
                      getChartData.labels &&
                      getChartData.labels.length > 0
                    "
                  >
                    <Doughnut
                      class="doughnut chart-doughnut"
                      :chart-data="getChartData"
                      :chart-options="chartOptions"
                    ></Doughnut>
                  </div>
                  <div v-else>
                    <h4 class="text-center my-5">No Data Available</h4>
                  </div>
              </b-card>
            </b-col>
          </b-row>
      </b-col>
      <b-col md="7">
        <b-row>
          <b-col md="2"></b-col>
          <b-col md="2" class="text-right">
            <a href="#">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            /></a>
          </b-col>
          <b-col md="4">
            <eb-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              :options="dateOption1"
              v-model="selectedDate1"
              :selected="selectedDate1.text"
              @input="changeDate1"
            >
            </eb-select>
            <b-modal
              title="Select Date"
              header-class="header-nipige-class"
              id="dateRange1"
              size="sm"
              ref="date-range1"
              centered
              hide-footer
            >
              <b-input
                class="mb-2"
                type="date"
                v-model="startDate1"
              ></b-input>
              <b-input type="date" v-model="endDate1"></b-input>
              <div class="text-center mt-2">
                <b-button
                  @click="findButtonClick1()"
                  class="my -0 main-navigation-button w-47 mr-2"
                  variant="success"
                  >Find
                </b-button>
              </div>
            </b-modal>
          </b-col>
          <b-col md="4">
            <ev-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              placeholder="Select Status"
              :options="statusOptions1"
              v-model="selectedStatusOptions1"
              :selected="selectedStatusOptions1.text"
              @input="changeStatus1"
            >
            </ev-select>
          </b-col>
        </b-row>
        <b-row class="mt-0">
          <b-col md="12" class="pt-0">
            <b-card style="height:100%">
              <h4>Top 10 Products</h4>
                <div
                  v-if="chartData && chartData.labels && chartData.labels.length > 0"
                >
                  <BarChart
                    :chart-data="chartData"
                    :chart-options="barChartOptions1"
                    class="h-100 mt-5"
                  />
                </div>
                <div v-else>
                  <h4 class="text-center my-5">No Data Available</h4>
                </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row> -->

            <b-row class="mt-3">
                <b-col md="8" class="pb-0"></b-col>
                <b-col md="1" class="text-right pb-0">
                    <!-- <a href="#">
        <img
          src="@/assets/images/DataExport.png"
          class="upload-btn"
          alt="data export"
        /></a> -->
                </b-col>
                <b-col md="3" class="pb-0">
                    <eb-select
                        ref="dateRef3"
                        style="background-color: #fff"
                        id="text"
                        type="text"
                        label="text"
                        :options="dateOption3"
                        v-model="selectedDate3"
                        :selected="selectedDate3.text"
                        @input="changeDate3"
                    >
                    </eb-select>
                    <c-date
                        ref="compRefs3"
                        modalRef="modalRef3"
                        modalId="dateModal3"
                        @customDateRange="findDateResult3"
                    ></c-date>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12" class="pt-0">
                    <b-card class="mt-0">
                        <h4>Order by Type</h4>
                        <div
                            v-if="
                                orderByTypeChartData &&
                                orderByTypeChartData.labels &&
                                orderByTypeChartData.labels.length > 0
                            "
                        >
                            <BarChart
                                :chart-data="orderByTypeChartData"
                                :chart-options="barChartOptions"
                            />
                        </div>

                        <div v-else>
                            <h4 class="text-center my-5">No Data Available</h4>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <!-- <b-row class="mb-3">
            <b-col md="6">
                <b-row>
                    <b-col md="8">
                        <h4>Sales by Tech</h4>
                    </b-col>
                    <b-col md="4">
                        <eb-select
                            id="selectedDate4"
                            type="text"
                            label="text"
                            v-model="selectedDate4"
                            :selected="selectedDate4.text"
                            @input="changeDate4"
                            :options="dateOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs4"
                            modalRef="modalRef4"
                            modalId="dateModal4"
                            @customDateRange="findDateResult4"
                        ></c-date>
                    </b-col>
                </b-row>
                <b-card>
                    <div
                        v-if="
                            chartData4 &&
                            chartData4.labels &&
                            chartData4.labels.length
                        "
                    >
                        <BarChart
                            :chart-data="chartData4"
                            :chart-options="barChartOptions4"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col md="8">
                        <h4>Sales by Region</h4>
                    </b-col>
                    <b-col md="4">
                        <eb-select
                            id="selectedDate5"
                            type="text"
                            label="text"
                            v-model="selectedDate5"
                            :selected="selectedDate5.text"
                            @input="changeDate5"
                            :options="dateOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs5"
                            modalRef="modalRef5"
                            modalId="dateModal5"
                            @customDateRange="findDateResult5"
                        ></c-date>
                    </b-col>
                </b-row>
                <b-card>
                    <div
                        v-if="
                            chartData5 &&
                            chartData5.labels &&
                            chartData5.labels.length
                        "
                    >
                        <BarChart
                            :chart-data="chartData5"
                            :chart-options="barChartOptions5"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col md="5">
                        <h4>DSO</h4>
                    </b-col>
                    <b-col md="3">
                        <eb-select
                            style="background-color: #fff"
                            id="reportData2DateFilter"
                            type="text"
                            label="text"
                            v-model="selectedDate6"
                            :selected="selectedDate6.text"
                            @input="changeDate6"
                            :options="dateOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs6"
                            modalRef="modalRef6"
                            modalId="dateModal6"
                            @customDateRange="findDateResult6"
                        ></c-date>
                    </b-col>
                    <b-col md="4">
                        <eb-select
                            type="select"
                            v-model="selectedCustomers"
                            :options="customerList"
                            label="text"
                            :id="'selectCustomer'"
                            @input="changeCustomer"
                            :selected="selectedCustomers"
                        ></eb-select>
                    </b-col>
                </b-row>

                <b-card>
                    <div
                        v-if="
                            pieData && pieData.labels && pieData.labels.length
                        "
                    >
                        <PieChart
                            :chart-data="pieData"
                            :chart-options="pieChartOptions"
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row> -->
        <!-- -----invoice data order detail view Start------ -->
        <!-- <b-row class="mb-3">
            <b-col md="12">
                <div class="invoice-data">
                    <b-row class="mt-0">
                        <b-col md="5">
                            <div>
                                <strong>Bill To</strong><br />
                                CBRE : CBRE Richmond<br />
                                Wes Newcome<br />
                                (571) 242-2182 x<br />
                                wes.newcome@cbre.com
                            </div>
                        </b-col>
                        <b-col md="7">
                            <div>
                                <strong>Primary Service Location</strong><br />
                                Bridgeway Business Center (0563590)<br />
                                6701 College Dr<br />
                                Suffolk, Virginia 23435-3336
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="invoice-table">
                    <table>
                        <tr>
                            <th>Job Date</th>
                            <th>Job#</th>
                            <th>PO#</th>
                            <th>Description</th>
                            <th>Location</th>
                            <th>Job Total</th>
                            <th>Job Deposits</th>
                            <th>Job Total Due</th>
                        </tr>
                        <tr>
                            <td>12/12/24</td>
                            <td>10676546543</td>
                            <td></td>
                            <td class="description">
                                1 hour/week<br />Inspect grounds for trash,
                                graffiti, exterior lights on during the day,
                                etc. Ensure landscaping is being maintained. UPS
                                building is on our parcel but we are not
                                responsible for their building.
                            </td>
                            <td>
                                6701 College Dr Suffolk, Virginia 23435-3336
                            </td>
                            <td>$95.00</td>
                            <td>$0.00</td>
                            <td>$95.00</td>
                        </tr>
                        <tr>
                            <td>12/12/24</td>
                            <td>10676546543</td>
                            <td></td>
                            <td>
                                1 hour/week<br />Inspect grounds for trash,
                                graffiti, exterior lights on during the day,
                                etc. Ensure landscaping is being maintained. UPS
                                building is on our parcel but we are not
                                responsible for their building.
                            </td>
                            <td>
                                6701 College Dr Suffolk, Virginia 23435-3336
                            </td>
                            <td>$95.00</td>
                            <td>$0.00</td>
                            <td>$95.00</td>
                        </tr>
                        <tr>
                            <td>12/12/24</td>
                            <td>10676546543</td>
                            <td></td>
                            <td>
                                1 hour/week<br />Inspect grounds for trash,
                                graffiti, exterior lights on during the day,
                                etc. Ensure landscaping is being maintained. UPS
                                building is on our parcel but we are not
                                responsible for their building.
                            </td>
                            <td>
                                6701 College Dr Suffolk, Virginia 23435-3336
                            </td>
                            <td>$95.00</td>
                            <td>$0.00</td>
                            <td>$95.00</td>
                        </tr>
                    </table>
                </div>
            </b-col>
        </b-row> -->
        <!-- -----invoice data order detail view End------ -->
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
import BarChart from "@/components/chart/BarChart";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import Doughnut from "@/components/chart/Doughnut.js";
import doughChartDataGenerator from "@/utils/doughChartDataGenerator";
import orderListBarChartDataGenerator from "@/utils/orderListBarChartDataGenerator";
import generateOrderByTypeChartData from "@/utils/generateOrderByTypeChartData";
import cDate from "@/components/FormElements/CustomDate.vue";
import PieChart from "@/components/chart/newPieChart.vue";
import { AtomSpinner } from "epic-spinners";
import User from "../userManagement/User.vue";

export default {
    name: "Reports",
    components: {
        BarChart,
        ComponentHeader,
        Doughnut,
        ebSelect,
        evSelect,
        cDate,
        AtomSpinner,
        PieChart,
    },
    data() {
        return {
            prevSelectedDate: null,
            prevSelectedDate1: null,
            prevSelectedDate2: null,
            prevSelectedDate3: null,
            loading: false,
            onlineOrder: 0,
            onlineOrderCount: 0,
            posOrder: 0,
            posOrderCount: 0,
            ongoingOrders: 0,
            ongoingOrdersCount: 0,
            pendingOrders: 0,
            pendingOrdersCount: 0,
            cancelledOrders: 0,
            cancelledOrderCount: 0,
            completedCount: 0,
            completedOrders: 0,
            serviceCount: 0,
            serviceOrders: 0,
            productOrder: 0,
            productOrderCount: 0,
            prePaidOrder: 0,
            prePaidOrderCount: 0,
            deliveryCount: 0,
            deliveryOrder: 0,
            totalCustomer: 0,
            totalOrder: 0,
            orderCount: 0,
            chartOptions: {
                hoverBorderWidth: 10,
            },
            selectedDate: {
                text: "Today",
                value: 1,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
            selectedDate1: {
                text: "Today",
                value: 1,
            },
            dateOption1: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate1: "",
            endDate1: "",
            selectedDate2: {
                text: "Today",
                value: 1,
            },
            dateOption2: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate2: "",
            endDate2: "",
            selectedDate3: {
                text: "Today",
                value: 1,
            },
            dateOption3: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate3: "",
            endDate3: "",
            barChartOptions1: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        position: "left",
                        title: {
                            display: true,
                            text: "Order Value",
                            font: {
                                size: 15,
                            },
                            color: "#002872",
                        },
                    },
                    y1: {
                        display: true,
                        position: "right",
                        title: {
                            display: true,
                            text: "Order Count",
                            font: {
                                size: 15,
                            },
                            color: "var(--primary)",
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                    },
                },
                plugins: {
                    title: {
                        position: "bottom",
                        display: true,
                        text: "Date",
                        font: {
                            size: 15,
                        },
                        color: "#",
                    },
                },
            },
            barChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                    },
                },
            },
            selectedStatusOptions: [],
            statusOptions: [
                "All Status",
                "Processing",
                "Delivered",
                "Created",
                "Out For Delivery",
                "Payment Failed",
                "Cancelled",
                "Rejected",
                "Returned",
                "Dispatched",
                "Refund",
                "Delivery Attached",
                "Confirmed",
            ],
            selectedStatusOptions1: [],
            selectedDate4: {
                text: "7 days",
                value: 6,
            },
            startDate2: "",
            endDate2: "",
            selectedDate5: {
                text: "7 days",
                value: 6,
            },
            startDate5: "",
            endDate5: "",
            selectedDate6: {
                text: "7 days",
                value: 6,
            },
            startDate6: "",
            endDate6: "",
            selectedCustomers: {
                text: "All",
                value: "All",
            },
        };
    },
    computed: {
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        getChartData() {
            let dataList =
                this.$store.getters["partner/getBulkAnalyticsReport"];
            let dataKey = undefined;
            switch (true) {
            case this.$currentUserData.role === "Admin":
            dataKey = "admin-orderbystatus-graph";
             break;
            case this.$currentUserData.category === "TA":
            dataKey = "orderbystatus-graph";
            break;
            case this.$currentUserData.category === "SELLER":
            dataKey = "seller-orderbystatus-graph";
            break;
            default:
            dataKey = "subdealer-orderbystatus-graph";
            break;
            }
            return doughChartDataGenerator(dataList, dataKey);
        },
        chartData() {
            let data = this.$store.getters["partner/getChartData"];
            let orderKey = "";
            let orderAmount = "";
            let orderCount = "";
            if (this.$currentUserData.role ==="Admin") {
                orderKey = "admin-orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }else if (this.$currentUserData.category === "TA") {
                orderKey = "orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            } else if (this.$currentUserData.category === "SELLER") {
                orderKey = "seller-orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                orderKey = "subdealer-orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            const orderList = data[orderKey];
            return orderListBarChartDataGenerator(
                orderList,
                orderAmount,
                orderCount,
            );
        },

        orderByTypeChartData() {
            let data = this.$store.getters["partner/GetOrderByTypeReport"];
            let posOrderKey = "";
            let posOrderAmount = "";
            let posOrderCount = "";
            let posDate = "";
            let posType = "";
            let onlineOrderKey = "";
            let onlineOrderAmount = "";
            let onlineOrderCount = "";
            let onlineDate = "";
            let onlineType = "";
            if(this.$currentUserData.role == "Admin") {
                posOrderKey = "admin-orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "admin-orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            } else if(this.$currentUserData.category == "TA") {
                posOrderKey = "orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            } else if (this.$currentUserData.category === "SELLER") {
                posOrderKey = "seller-orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "seller-orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                posOrderKey = "subdealer-orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "subdealer-orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            }
            const posOrderList = data[posOrderKey];
            const onlineOrderList = data[onlineOrderKey];
            return generateOrderByTypeChartData(
                posOrderList,
                posOrderAmount,
                posOrderCount,
                posDate,
                posType,
                onlineOrderList,
                onlineOrderAmount,
                onlineOrderCount,
                onlineDate,
                onlineType,
            );
        },
        chartData4() {
            const dataList = this.$store.getters["partner/getSalesByTech"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Sales",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                    yAxisID: "y",
                },
                {
                    label: "Count Of Sales",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                    yAxisID: "y2",
                },
            ];

            if (dataList && dataList["sales-by-tech"]) {
                if (dataList["sales-by-tech"].length > 0) {
                    dataList["sales-by-tech"].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(parseInt(el.total_sales));
                        dataSets[1].data.push(parseInt(el.count_of_sales));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions4() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y2: {
                        display: true,
                        beginAtZero: true,
                        suggestedMax: 3, // 👈 Adjusted to prevent stretching
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        position: "right",

                        ticks: {
                            display: false, // 👈 Ensure it only shows whole numbers
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData5() {
            const dataList = this.$store.getters["partner/getSalesByRegion"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Customers",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                    yAxisID: "y",
                },
                {
                    label: "Total Sales",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                    yAxisID: "y2",
                },
            ];

            if (dataList && dataList["sales-by-region"]) {
                if (dataList["sales-by-region"].length > 0) {
                    dataList["sales-by-region"].map((el) => {
                        labels.push(el["Customer Region"]);
                        dataSets[0].data.push(parseInt(el.total_count));
                        dataSets[1].data.push(parseInt(el.total_sales));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions5() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y2: {
                        display: true,
                        beginAtZero: true,
                        suggestedMax: 3, // 👈 Adjusted to prevent stretching
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        // position: "right",

                        ticks: {
                            display: false, // 👈 Ensure it only shows whole numbers
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        pieData() {
            const isAllSelected =
                this.selectedCustomer &&
                this.selectedCustomer.toLowerCase() === "all";
            const data = this.$store.getters["partner/GetNumberOfDSO"];
            const dsoKey = isAllSelected ? "all-no-of-dso" : "no-of-dso";
            const labels = [];
            const dataSets = [
                {
                    data: [],
                    backgroundColor: [
                        // "#42A5F5", // Blue
                        "#FF6384", // Red
                        "#36A2EB", // Light Blue
                        "#FFCD56", // Yellow
                        // "#4CAF50", // Green
                        // "#FF9800", // Orange
                        // "#9C27B0", // Purple
                        // "#E91E63", // Pink
                        // "#2196F3", // Light Blue
                        // "#FFC107", // Amber
                    ],
                    hoverBackgroundColor: [
                        // "#64B5F6", // Hover Blue
                        "#FF8A80", // Hover Red
                        "#42A5F5", // Hover Light Blue
                        "#FFD54F", // Hover Yellow
                        // "#81C784", // Hover Green
                        // "#FFB74D", // Hover Orange
                        // "#BA68C8", // Hover Purple
                        // "#F06292", // Hover Pink
                        // "#64B5F6", // Hover Light Blue
                        // "#FFEB3B", // Hover Amber
                    ],
                },
            ];
            if (data && data[dsoKey]) {
                if (data[dsoKey].length > 0) {
                    data[dsoKey].map((el) => {
                        labels.push(el.Type);
                        dataSets[0].data.push(parseInt(el.num_of_invoices));
                        // dataSets[0].data.push(parseInt(el.total_amount));
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        pieChartOptions() {
            const isAllSelected =
                this.selectedCustomer &&
                this.selectedCustomer.toLowerCase() === "all";
            const dsoKey = isAllSelected ? "all-no-of-dso" : "no-of-dso";
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "top",
                    },
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                const data =
                                    this.$store.getters[
                                        "partner/GetNumberOfDSO"
                                    ];
                                if (data && data[dsoKey]) {
                                    const item = data[dsoKey].find(
                                        (el) => el.Type === tooltipItem.label,
                                    );
                                    if (item) {
                                        return `Total Amount: ${item.total_amount} No. of Invoice: ${item.num_of_invoices}`;
                                    }
                                }
                                // return tooltipItem.raw;
                            },
                        },
                    },
                    datalabels: {
                        anchor: "start",
                        align: "start",
                        formatter: (value, context) => {
                            const data =
                                this.$store.getters["partner/GetNumberOfDSO"];
                            const dsoKey = isAllSelected
                                ? "all-no-of-dso"
                                : "no-of-dso";
                            if (data && data[dsoKey]) {
                                const item = data[dsoKey].find(
                                    (el) =>
                                        el.Type ===
                                        context.chart.data.labels[
                                            context.dataIndex
                                        ],
                                );
                                if (item) {
                                    return `Total Amount: ${item.total_amount}\n No. of Invoice: ${item.num_of_invoices}`;
                                }
                            }
                        },
                    },
                },
            };
        },
        customerList() {
            let data = this.$store.getters["partner/getCustomerListData"];
            const customerDataList = data["customer-list"]
                ? data["customer-list"].map((d) => {
                      return {
                          text: d.Customer_Name,
                          value: d.Customer_Name,
                      };
                  })
                : [];
            customerDataList.unshift({ text: "All", value: "all" });
            return customerDataList;
        },
    },

    methods: {
        findDateResult2(e) {
            ((this.startDate2 = e.fromDate),
                (this.endDate2 = e.toDate),
                this.dashboardReport());
        },
        changeDate2(e) {
            if (e.value === "custom") {
                this.prevSelectedDate2 = { ...this.selectedDate2 };
                this.selectedDate2 = this.prevSelectedDate2;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef2"] &&
                        this.$refs["dateRef2"].close
                    ) {
                        this.$refs["dateRef2"].close();
                    } else if (
                        this.$refs["dateRef2"] &&
                        this.$refs["dateRef2"].$el
                    ) {
                        const el =
                            this.$refs["dateRef2"].$el.querySelector("input") ||
                            this.$refs["dateRef2"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs2"].openModal();
                });
            } else {
                this.dashboardReport();
            }
        },
        getDateData(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        getDateData2(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate2,
                    toDate: this.endDate2,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async dashboardReport() {
            if (this.$currentUserData.role === "Admin") {
                const payload = {
                    items: [
                        {
                            key: "admin-total-order",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-prepaid-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-online-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-cod-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-product-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-service-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-pending-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-completed-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-ongoing-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-cancelled-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "admin-pos-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.prePaidOrder = (
                    +(
                        data["admin-prepaid-orders"] &&
                        data["admin-prepaid-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.prePaidOrderCount =
                    (data["admin-prepaid-orders"] &&
                        data["admin-prepaid-orders"].total_order) ||
                    0;

                this.deliveryCount =
                    (data["admin-cod-orders"] &&
                        data["admin-cod-orders"].total_order) ||
                    0;

                this.deliveryOrder = (
                    +(
                        data["admin-cod-orders"] &&
                        data["admin-cod-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.productOrder = (
                    +(
                        data["admin-product-orders"] &&
                        data["admin-product-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.productOrderCount =
                    (data["admin-product-orders"] &&
                        data["admin-product-orders"].total_order) ||
                    0;

                this.serviceOrder = (
                    +(
                        data["admin-service-orders"] &&
                        data["admin-service-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.serviceOrderCount =
                    (data["admin-service-orders"] &&
                        data["admin-service-orders"].total_order) ||
                    0;

                this.pendingOrderCount =
                    (data["admin-pending-orders"] &&
                        data["admin-pending-orders"].total_order) ||
                    0;

                this.pendingOrderAmount = (
                    +(
                        data["admin-pending-orders"] &&
                        data["admin-pending-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.completedCount =
                    (data["admin-completed-orders"] &&
                        data["admin-completed-orders"].total_order) ||
                    0;

                this.completedOrders = (
                    +(
                        data["admin-completed-orders"] &&
                        data["admin-completed-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.ongoingOrderCount =
                    (data["admin-ongoing-orders"] &&
                        data["admin-ongoing-orders"].total_order) ||
                    0;

                this.ongoingOrderAmount = (
                    +(
                        data["admin-ongoing-orders"] &&
                        data["admin-ongoing-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.cancelledOrderCount =
                    (data["admin-cancelled-orders"] &&
                        data["admin-cancelled-orders"].total_order) ||
                    0;

                this.cancelledOrders = (
                    +(
                        data["admin-cancelled-orders"] &&
                        data["admin-cancelled-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.posOrderCount =
                    (data["admin-pos-orders"] &&
                        data["admin-pos-orders"].total_order) ||
                    0;

                this.posOrderAmount = (
                    +(
                        data["admin-pos-orders"] &&
                        data["admin-pos-orders"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.totalOrder = (
                    +(
                        data["admin-total-order"] &&
                        data["admin-total-order"].total_order_amount
                    ) || 0
                ).toFixed(2);

                this.orderCount =
                    (data["admin-total-order"] &&
                        data["admin-total-order"].total_order) ||
                    0;
            } else if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: "total-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "prepaid-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "online-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "cod-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "product-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "service-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "pending-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "completed-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "ongoing-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "cancelled-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "pos-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.onlineOrder = (
                    +data["online-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.onlineOrderCount = data["online-orders"]?.total_order || 0;
                this.posOrder = (
                    +data["pos-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.posOrderCount = data["pos-orders"]?.total_order || 0;
                this.ongoingOrders = (
                    +data["ongoing-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.ongoingOrdersCount =
                    data["ongoing-orders"]?.total_order || 0;
                this.pendingOrders = (
                    +data["pending-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.pendingOrdersCount =
                    data["pending-orders"]?.total_order || 0;
                this.cancelledOrders = (
                    +data["cancelled-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.cancelledOrderCount =
                    data["cancelled-orders"]?.total_order || 0;
                this.completedCount =
                    data["completed-orders"]?.total_order || 0;
                this.completedOrders = (
                    +data["completed-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.serviceCount = data["service-orders"]?.total_order || 0;
                this.serviceOrders = (
                    +data["service-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.productOrder = (
                    +data["product-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.productOrderCount =
                    data["product-orders"]?.total_order || 0;
                this.prePaidOrder = (
                    +data["prepaid-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.prePaidOrderCount =
                    data["prepaid-orders"]?.total_order || 0;
                this.deliveryCount = data["cod-orders"]?.total_order || 0;
                this.deliveryOrder = (
                    +data["cod-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.totalOrder = (
                    +data["total-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.orderCount = data["total-orders"]?.total_order || 0;
            } else if (this.$currentUserData.category === "SELLER") {
                const payload = {
                    items: [
                        {
                            key: "seller-total-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-pos-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-prepaid-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-online-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-cod-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-product-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-service-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-pending-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-completed-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-ongoing-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-cancelled-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.onlineOrder = (
                    +data["seller-online-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.onlineOrderCount =
                    data["seller-online-orders"]?.total_order || 0;
                this.posOrder = (
                    +data["seller-pos-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.posOrderCount =
                    data["seller-pos-orders"]?.total_order || 0;
                this.ongoingOrders = (
                    +data["seller-ongoing-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.ongoingOrdersCount =
                    data["seller-ongoing-orders"]?.total_order || 0;

                this.pendingOrders = (
                    +data["seller-pending-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.pendingOrdersCount =
                    data["seller-pending-orders"]?.total_order || 0;

                this.cancelledOrders = (
                    +data["seller-cancelled-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.cancelledOrderCount =
                    data["seller-cancelled-orders"]?.total_order || 0;

                this.completedCount =
                    data["seller-completed-orders"]?.total_order || 0;

                this.completedOrders = (
                    +data["seller-completed-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.serviceCount =
                    data["seller-service-orders"]?.total_order || 0;

                this.serviceOrders = (
                    +data["seller-service-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.productOrder = (
                    +data["seller-product-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.productOrderCount =
                    data["seller-product-orders"]?.total_order || 0;

                this.prePaidOrder = (
                    +data["seller-prepaid-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.prePaidOrderCount =
                    data["seller-prepaid-orders"]?.total_order || 0;

                this.deliveryCount =
                    data["seller-cod-orders"]?.total_order || 0;

                this.deliveryOrder = (
                    +data["seller-cod-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.totalOrder = (
                    +data["seller-total-orders"]?.total_order_amount || 0
                ).toFixed(2);

                this.orderCount = data["seller-total-orders"]?.total_order || 0;
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                const payload = {
                    items: [
                        {
                            key: "subdealer-total-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-pos-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-prepaid-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-online-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-cod-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-product-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-service-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-pending-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-completed-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-ongoing-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-cancelled-orders",
                            variables: {
                                ...this.getDateData2(this.selectedDate2.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );
                this.onlineOrder = (
                    +data["subdealer-online-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.onlineOrderCount =
                    data["subdealer-online-orders"]?.total_order || 0;
                this.posOrder = (
                    +data["subdealer-pos-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.posOrderCount =
                    data["subdealer-pos-orders"]?.total_order || 0;
                this.ongoingOrders = (
                    +data["subdealer-ongoing-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.ongoingOrdersCount =
                    data["subdealer-ongoing-orders"]?.total_order || 0;
                this.pendingOrders = (
                    +data["subdealer-pending-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.pendingOrdersCount =
                    data["subdealer-pending-orders"]?.total_order || 0;
                this.cancelledOrders = (
                    +data["subdealer-cancelled-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.cancelledOrderCount =
                    data["subdealer-cancelled-orders"]?.total_order || 0;
                this.completedCount =
                    data["subdealer-completed-orders"]?.total_order || 0;
                this.completedOrders = (
                    +data["subdealer-completed-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.serviceCount =
                    data["subdealer-service-orders"]?.total_order || 0;
                this.serviceOrders = (
                    +data["subdealer-service-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.productOrder = (
                    +data["subdealer-product-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.productOrderCount =
                    data["subdealer-product-orders"]?.total_order || 0;
                this.prePaidOrder = (
                    +data["subdealer-prepaid-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.prePaidOrderCount =
                    data["subdealer-prepaid-orders"]?.total_order || 0;
                this.deliveryCount =
                    data["subdealer-cod-orders"]?.total_order || 0;
                this.deliveryOrder = (
                    +data["subdealer-cod-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.totalOrder = (
                    +data["subdealer-total-orders"]?.total_order_amount || 0
                ).toFixed(2);
                this.orderCount =
                    data["subdealer-total-orders"]?.total_order || 0;
            }
        },
        findDateResult(e) {
            ((this.startDate = e.fromDate),
                (this.endDate = e.toDate),
                this.fetchOrderStatusChart());
        },
        changeDate(e) {
            if (e.value === "custom") {
                this.prevSelectedDate = { ...this.selectedDate };
                this.selectedDate = this.prevSelectedDate;
                this.$nextTick(() => {
                    if (this.$refs["dateRef"] && this.$refs["dateRef"].close) {
                        this.$refs["dateRef"].close();
                    } else if (
                        this.$refs["dateRef"] &&
                        this.$refs["dateRef"].$el
                    ) {
                        const el =
                            this.$refs["dateRef"].$el.querySelector("input") ||
                            this.$refs["dateRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs"].openModal();
                });
            } else {
                this.fetchOrderStatusChart();
            }
        },
        async fetchOrderStatusChart() {
            if (this.$currentUserData.role === "Admin") {
                const payload = {
                    items: [
                        {
                            key: "admin-orderbystatus-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                ...this.getStatusData(
                                    this.selectedStatusOptions,
                                ),
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchBulkChart", payload);
            }else if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: "orderbystatus-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                ...this.getStatusData(
                                    this.selectedStatusOptions,
                                ),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchBulkChart", payload);
            } else if (this.$currentUserData.category === "SELLER") {
                const payload = {
                    items: [
                        {
                            key: "seller-orderbystatus-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                ...this.getStatusData(
                                    this.selectedStatusOptions,
                                ),
                                tenant: this.$currentUserData.tenant,
                                userId: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchBulkChart", payload);
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                const payload = {
                    items: [
                        {
                            key: "subdealer-orderbystatus-graph",
                            variables: {
                                ...this.getDateData(this.selectedDate.value),
                                ...this.getStatusData(
                                    this.selectedStatusOptions,
                                ),
                                tenant: this.$currentUserData.tenant,
                                userId: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchBulkChart", payload);
            }
        },

        findDateResult1(e) {
            ((this.startDate1 = e.fromDate),
                (this.endDate1 = e.toDate),
                this.fetchOrderValueChart());
        },
        changeDate1(e) {
            if (e.value === "custom") {
                this.prevSelectedDate1 = { ...this.selectedDate1 };
                this.selectedDate1 = this.prevSelectedDate1;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].close
                    ) {
                        this.$refs["dateRef1"].close();
                    } else if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateRef1"].$el.querySelector("input") ||
                            this.$refs["dateRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs1"].openModal();
                });
            } else {
                this.fetchOrderValueChart();
            }
        },
        getDateData1(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate1,
                    toDate: this.endDate1,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        changeStatus(e) {
            if (e.some((el) => el === "All Status")) {
                if (e.indexOf("All Status") === 0 && e.length > 1) {
                    e.splice(e.indexOf("All Status"), 1);
                    this.selectedStatusOptions = e;
                } else {
                    this.selectedStatusOptions = ["All Status"];
                }
            } else {
                this.selectedStatusOptions = e;
            }
            this.fetchOrderStatusChart();
        },
        getStatusData(statusData) {
            let data = {};
            if (
                statusData.length === 0 ||
                statusData.some((el) => el === "All Status")
            ) {
                this.statusOptions.forEach((el, index) => {
                    if (el !== "All Status") {
                        data[`status${index}`] = el;
                    }
                });
            } else {
                statusData.forEach((el, index) => {
                    data[`status${index + 1}`] = el;
                });
            }
            return data;
        },
        changeStatus1(e) {
            if (e.some((el) => el === "All Status")) {
                if (e.indexOf("All Status") === 0 && e.length > 1) {
                    e.splice(e.indexOf("All Status"), 1);
                    this.selectedStatusOptions1 = e;
                } else {
                    this.selectedStatusOptions1 = ["All Status"];
                }
            } else {
                this.selectedStatusOptions1 = e;
            }
            this.fetchOrderValueChart();
        },

        findDateResult3(e) {
            ((this.startDate3 = e.fromDate),
                (this.endDate3 = e.toDate),
                this.fetchOrderByTypeChart());
        },
        changeDate3(e) {
            if (e.value === "custom") {
                this.prevSelectedDate3 = { ...this.selectedDate3 };
                this.selectedDate3 = this.prevSelectedDate3;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef3"] &&
                        this.$refs["dateRef3"].close
                    ) {
                        this.$refs["dateRef3"].close();
                    } else if (
                        this.$refs["dateRef3"] &&
                        this.$refs["dateRef3"].$el
                    ) {
                        const el =
                            this.$refs["dateRef3"].$el.querySelector("input") ||
                            this.$refs["dateRef3"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs3"].openModal();
                });
            } else {
                this.fetchOrderByTypeChart();
            }
        },
        getDateData3(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate3,
                    toDate: this.endDate3,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchOrderByTypeChart() {
            if (this.$currentUserData.role === "Admin") {
                const payload = {
                    items: [
                        {
                            key: "admin-orderbytype-pos-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                            },
                        },
                        {
                            key: "admin-orderbytype-online-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchOrderByTypeChartReport",
                    payload,
                );
            }
            else if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: "orderbytype-pos-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                                tenant: this.userId,
                            },
                        },
                        {
                            key: "orderbytype-online-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchOrderByTypeChartReport",
                    payload,
                );
            } else if (this.$currentUserData.category === "SELLER") {
                const payload = {
                    items: [
                        {
                            key: "seller-orderbytype-pos-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "seller-orderbytype-online-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchOrderByTypeChartReport",
                    payload,
                );
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                const payload = {
                    items: [
                        {
                            key: "subdealer-orderbytype-pos-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                        {
                            key: "subdealer-orderbytype-online-graph",
                            variables: {
                                ...this.getDateData3(this.selectedDate3.value),
                                userId: this.userId,
                                tenant: this.$currentUserData.tenant,
                            },
                        },
                    ],
                };
                await this.$store.dispatch(
                    "partner/fetchOrderByTypeChartReport",
                    payload,
                );
            }
        },

        async fetchOrderValueChart() {
            if (this.$currentUserData.role === "Admin") {
                const payload = {
                    items: [
                        {
                            key: "admin-orderbyvalue-graph",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                               ...this.getStatusData(
                                    this.selectedStatusOptions1,
                                ),
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchChart", payload);
            } else if (this.$currentUserData.category === "TA") {
                const payload = {
                    items: [
                        {
                            key: "orderbyvalue-graph",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                ...this.getStatusData(
                                    this.selectedStatusOptions1,
                                ),
                                tenant: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchChart", payload);
            } else if (this.$currentUserData.category === "SELLER") {
                const payload = {
                    items: [
                        {
                            key: "seller-orderbyvalue-graph",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                ...this.getStatusData(
                                    this.selectedStatusOptions1,
                                ),
                                tenant: this.$currentUserData.tenant,
                                userId: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchChart", payload);
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                const payload = {
                    items: [
                        {
                            key: "subdealer-orderbyvalue-graph",
                            variables: {
                                ...this.getDateData1(this.selectedDate1.value),
                                ...this.getStatusData(
                                    this.selectedStatusOptions1,
                                ),
                                tenant: this.$currentUserData.tenant,
                                userId: this.userId,
                            },
                        },
                    ],
                };
                await this.$store.dispatch("partner/fetchChart", payload);
            }
        },
        createRequest() {
            const payload = {
                filterBy: {
                    ...this.getDateData(this.selectedDate.value),
                    collectionName: "ORDER",
                },
                requestBy: {
                    _id: this.$currentUserData._id,
                    name: this.$currentUserData.userName,
                    email: this.$currentUserData.email,
                    phone: this.$currentUserData.phone,
                },
            };
            this.$store
                .dispatch("partner/createRequestDownload", payload)
                .then(() => {
                    this.$swal({
                        title: "Success",
                        text: "Request successful!!",
                        type: "success",
                    });
                })
                .catch((error) =>
                    this.$toasted.error(
                        error.message
                            ? error.message
                            : "Error Request could not completed",
                    ),
                );
        },
        changeDate4(e) {
            this.selectedDate4 = e;
            if (e.value == "custom") {
                this.$refs["compRefs4"].openModal();
                return;
            }
            this.fetchSalesByTechData();
        },
        findDateResult4(e) {
            this.startDate4 = e.fromDate;
            this.endDate4 = e.toDate;
            this.fetchSalesByTechData();
        },

        getDateData4(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate4,
                    toDate: this.endDate4,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchSalesByTechData() {
            const data = [
                {
                    key: "sales-by-tech",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData4(this.selectedDate4.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumnerSalesTech", {
                items: data,
            });
        },
        changeDate5(e) {
            this.selectedDate5 = e;
            if (e.value == "custom") {
                this.$refs["compRefs5"].openModal();
                return;
            }
            this.fetchSalesByRegionData();
        },
        findDateResult5(e) {
            this.startDate5 = e.fromDate;
            this.endDate5 = e.toDate;
            this.fetchSalesByRegionData();
        },

        getDateData5(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate5,
                    toDate: this.endDate5,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchSalesByRegionData() {
            const data = [
                {
                    key: "sales-by-region",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData5(this.selectedDate5.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumnerSalesRegion", {
                items: data,
            });
        },
        changeDate6(e) {
            this.selectedDate6 = e;
            if (e.value == "custom") {
                this.$refs["compRefs6"].openModal();
                return;
            }
            this.changeCustomer();
        },
        findDateResult6(e) {
            this.startDate6 = e.fromDate;
            this.endDate6 = e.toDate;
            this.changeCustomer();
        },

        getDateData6(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate6,
                    toDate: this.endDate6,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchNumberOfDSO(value) {
            this.isLoading = true;
            const data = [
                {
                    key: "no-of-dso",
                    variables: {
                        ...this.getDateData6(this.selectedDate6.value),
                        Customer: value.value,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfDSO", {
                items: data,
            });
            this.isLoading = false;
        },
        async fetchAllNumberOfDSO() {
            this.isLoading = true;
            const data = [
                {
                    key: "all-no-of-dso",
                    variables: {
                        ...this.getDateData6(this.selectedDate6.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfDSO", {
                items: data,
            });
            this.isLoading = false;
        },

        async fetchCustomerList() {
            const data = [
                {
                    key: "customer-list",
                    variables: {},
                },
            ];
            await this.$store.dispatch("partner/fetchCustomerListData", {
                items: data,
            });
        },

        async changeCustomer(selected) {
            this.selectedCustomer = selected ? selected.value : "All";

            if (this.selectedCustomer.toLowerCase() === "all") {
                await this.fetchAllNumberOfDSO(selected);
            } else {
                await this.fetchNumberOfDSO(selected);
            }
        },
    },

    mounted() {
        this.changeCustomer();
        this.dashboardReport();
        this.fetchOrderStatusChart();
        this.fetchOrderValueChart();
        this.fetchOrderByTypeChart();
        this.fetchSalesByTechData();
        this.fetchSalesByRegionData();
        this.fetchCustomerList();
    },
};
</script>

<style scoped>
.total-order-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.orderbySale-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.orderbyStatus-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.card.total-order-header {
    height: 270px;
}

.card.orderbySale-header {
    height: 270px;
}

.card.orderbyStatus-header {
    height: 270px;
}

.total-order-header {
    margin-bottom: 25px !important;
}

.green-chart-icon i {
    background: #def6ee;
    text-align: center;
    color: #65d27d;
    border-radius: 5px;
    font-size: 16px !important;
    height: 36px;
    width: 36px;
    line-height: 36px;
}

.red-chart-icon i {
    background: #f6dede;
    text-align: center;
    color: #fd8181;
    border-radius: 5px;
    font-size: 16px !important;
    height: 36px;
    width: 36px;
    line-height: 36px;
}

.order-price-heading {
    line-break: anywhere;
    line-height: 24px;
}

.chart-doughnut {
    height: 400px;
    width: 400px;
    margin-left: -5%;
}

.upload-btn {
    height: 39px;
}

.no-data-margin {
    margin-top: 196px;
    margin-bottom: 196px;
}

/* -----invoice css Start---- */
.invoice-data {
    margin: auto;
    border: 1px solid #aaaaaa;
    padding: 20px;
}
.invoice-data strong {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.invoice-data div {
    font-size: 14px;
    font-weight: 400;
    color: #000;
}
.invoice-table {
    margin: auto;
    border: 1px solid #aaaaaa;
    padding: 20px;
    border-top: none;
    padding-top: 10px;
}
.invoice-table table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 0;
    border: none;
}
.invoice-table td {
    border: none;
    padding: 8px;
    text-align: left;
    font-size: 13px;
    font-weight: 400;
    color: #5f5d5f;
}
.invoice-table th {
    background-color: transparent;
    font-size: 14px;
    font-weight: 600;
    color: #000000;
    border: none;
    padding: 8px;
    text-align: left;
}
.invoice-table .description {
    width: 450px;
}
/* -----invoice css End---- */
</style>
